import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './LanguageToggle.module.css';

export default function LanguageToggle() {
  const { lang, toggle, t } = useLanguage();
  const nextLabel = lang === 'am' ? t('lang.toggleToEnglish') : t('lang.toggleToAmharic');

  return (
    <button
      type="button"
      className={styles.button}
      onClick={toggle}
      aria-label={t('lang.label')}
      title={t('lang.label')}
    >
      {nextLabel}
    </button>
  );
}
